export default __webpack_public_path__ + "static/dashboard-4bb222df426a7eac7f9ec4067a0cbdab.png";